export default __webpack_public_path__ + "static/media/Opposites02_17.b350c3af.png";